module.exports = __webpack_public_path__ + "img/story032@2x.5f87ca47.png";